/** @module Specification/NewFromDataPackageTemplatesWizard */
define([
    "dojo/_base/declare",
    "csi/_base/underscore",
    "csi/xml",
    "csi/table/New",
    "csi/xml/Query",
    "csi/wizard/ActionControllerMixin"
], function(declare,_,xml,New,Query,ActionControllerMixin) {

    return declare([New, ActionControllerMixin], {

        /**
         * disable Finish & Go since action can create multiple data packages
         */
        _canNavigate: function() {
            return false;
        },

        /**
         * @Override
         *
          * Disable Finish button if:
         *    (1) no template is selected (C8-25382); or
         *    (2) among selected data package templates there are supplier specific
         */
        disableFinish: function(wizard, page, index) {
            return _.isEmpty(this.m_formData.getSelectedNodes()) || (index==0 && !this.disableNext(wizard, page, index));
        },

        /**
         * @Override
         *
         * Disable Next button if among selected data package only not supplier specific templates
         */
        disableNext: function(wizard, page, index) {
            var fd = this.m_formData;
            return !_.some(fd.getSelectedNodes(), function(dataPackageTemplate){
                return dataPackageTemplate.IsSupplierSpecific;
            });
        },

        /**
         * @Override
         *
         * More than one selection is allowed in the wizard, no validation is needed, require at least one selection
         */
        getFormData: function() {
            // summary: for now use to select multiple colors, but in end will represent single selected product
            var fd = this.inherited(arguments);
            fd.m_bRequireOne = true;
            fd.m_bSelectOne = false;
            this.bValidate = false;
            return fd;
        },

        /**
         * @Override
         *
         * Filter only active templates for product type that corresponds with the current product
         */
        getWizardViewQuery: function(wizard, view, index) {
            if (index == 0) {
                return new Query()
                            .Attr("Active", xml.OP_EQUALS, true)
                            .Attr("TemplateType", xml.OP_EQUALS, "DataPackageContainerType:" + this.getParent().$Type);
            }

            return this.inherited(arguments);
        },

        /**
         * @Override
         *
         * Create a request
         */
        toWriter: function() {
            var fd = this.m_formData;

            var w = this.m_writer;
            var req = this.m_action.m_request;
            var call = w.callMethod(req.m_module, req.m_operation);

            call.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.getParentURL());

            var selectedDataPackageTemplates = _.filter(fd.getSelectedNodes(), function(node){
                return node.$Type == "DataPackageTemplate";
            });

            var selectedDataPackageTemplatesURLs = _.map(selectedDataPackageTemplates, function(node){
                return node.$URL;
            });

            var selecteProductSources = _.filter(fd.getSelectedNodes(), function(node){
                return node.$Type == "ProductSource" || node.$Type == "FoodSource";
            });

            var selecteProductSourcesURLs = _.map(selecteProductSources, function(node){
                return node.$URL;
            });

            call.addParameter("DataPackageTemplates", xml.ATTR_REFLIST, selectedDataPackageTemplatesURLs);
            call.addParameter("ProductSources", xml.ATTR_REFLIST, selecteProductSourcesURLs);
            return call;
        }
    });
});